"use strict";
exports.__esModule = true;
exports.ServiceRegistry = void 0;
var ServiceRegistry = (function () {
    function ServiceRegistry() {
        this.services = {};
    }
    ServiceRegistry.getInstance = function () {
        if (!ServiceRegistry._instance) {
            ServiceRegistry._instance = new ServiceRegistry();
        }
        return ServiceRegistry._instance;
    };
    ServiceRegistry.prototype.getService = function (type) {
        var service = this.services[type];
        if (!service)
            throw new Error("Service ".concat(type, " not registered"));
        return service;
    };
    ServiceRegistry.prototype.registerService = function (type, service) {
        this.services[type] = service;
        return this;
    };
    return ServiceRegistry;
}());
exports.ServiceRegistry = ServiceRegistry;
//# sourceMappingURL=serviceRegistry.js.map